module.exports = __webpack_public_path__ + "static/media/avatar-empty.23a3776b.jpeg";